// extracted by mini-css-extract-plugin
export default {"backofficePaymentBadge":"NekbK5ZHYvyxa00aaPki","content":"WGvb9rafzBYaHrRzXRQW"};